export default "__VITE_PUBLIC_ASSET__d36a1358__"